module.exports = __webpack_public_path__ + "img/designing-mechanical-parts-by-en.9bf7b58d.jpg";